import "./StartPage.scss"
import mars from "../../img/mars-txt.png"
import illustration from "../../img/ilustration.png"

const StartPage = () => {
    return (
        <section className="StartPage">
            <div className="StartPage-description">
                <p className="StartPage-description-p-team">
                    UKRAINIAN TEAM <br/> OF PASSIONATE <br/> RESEARCHERS &
                    <a className="StartPage-description-link" href="https://apps.ucu.edu.ua/" target="_blank" rel="noreferrer">
                        UCU.
                        <span className="StartPage-description-link-color">APPS</span>
                    </a>
                    STUDENTS
                </p>
                <div className="StartPage-description-competition">
                    <a className="StartPage-description-competition-link" href="https://roverchallenge.eu/" target="_blank" rel="noreferrer">
                        EUROPEAN ROVER <br/> CHALLENGE 2026 <br/>
                    </a>
                    <span className="StartPage-description-competition-color">PARTICIPANTS</span>
                </div>
            </div>
            <div className="StartPage-img">
                <img
                    className="StartPage-illustration"
                    src={illustration}
                    alt="illustration"
                />
                <img
                    className="StartPage-mars"
                    src={mars}
                    alt="mars"
                />
            </div>
            <h1>FOR UKRAINE. <br/><span>FOR THE FUTURE.</span> </h1>
        </section>
    );
}
export default StartPage;